export default {
  loading: false,
  requireNewPassword: null,
  error: true
}